export default {"src":"/_next/static/media/ico-volts.4e4a6b8a.svg","height":149,"width":172,"blurWidth":0,"blurHeight":0};